var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
const SvgBathroomBlue = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.875 13.5416V16.6666C21.875 17.7717 21.436 18.8315 20.6546 19.6129C19.8732 20.3943 18.8134 20.8333 17.7083 20.8333H7.29167C6.1866 20.8333 5.12679 20.3943 4.34539 19.6129C3.56399 18.8315 3.125 17.7717 3.125 16.6666V14.1666C3.125 14.0009 3.19085 13.8419 3.30806 13.7247C3.42527 13.6075 3.58424 13.5416 3.75 13.5416H21.875Z",
    fill: "#133155",
    stroke: "#133155",
    strokeWidth: 1.5625,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.667 20.8333L17.7087 22.9167M8.33366 20.8333L7.29199 22.9167M21.8753 13.5417V7.29167C21.8753 6.1866 21.4363 5.12679 20.6549 4.34539C19.8735 3.56399 18.8137 3.125 17.7087 3.125H12.5003",
    stroke: "#133155",
    strokeWidth: 1.5625,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M16.0412 8.33333H8.95785C8.61305 8.33333 8.33701 8.05417 8.37451 7.71042C8.5266 6.32812 9.2318 3.125 12.4995 3.125C15.7672 3.125 16.4724 6.32812 16.6245 7.71042C16.662 8.05417 16.386 8.33333 16.0412 8.33333Z",
    fill: "#133155",
    stroke: "#133155",
    strokeWidth: 1.5625,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgBathroomBlue, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/bathroom-blue.892fc631.svg";
export { ForwardRef as ReactComponent };